"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getYearFromDateTimeString = exports.getMonthFromDateTimeString = exports.getCurrentDateString = exports.getDayFromDateObject = exports.stripColon = exports.getDateFromDateTimeString = void 0;
/**
 * Returns a new date object.
 * @param dateTimeString dateTime in format yyyymmddhhmm
 */
var getDateFromDateTimeString = function (dateTimeString) {
    var year = parseInt(dateTimeString === null || dateTimeString === void 0 ? void 0 : dateTimeString.substring(0, 4));
    var month = parseInt(dateTimeString === null || dateTimeString === void 0 ? void 0 : dateTimeString.substring(4, 6));
    var day = parseInt(dateTimeString === null || dateTimeString === void 0 ? void 0 : dateTimeString.substring(6, 8));
    var hour = parseInt(dateTimeString === null || dateTimeString === void 0 ? void 0 : dateTimeString.substring(8, 10));
    var minute = parseInt(dateTimeString === null || dateTimeString === void 0 ? void 0 : dateTimeString.substring(10));
    var date = new Date(year, month - 1, day);
    date.setHours(hour, minute, 0, 0);
    return date;
};
exports.getDateFromDateTimeString = getDateFromDateTimeString;
var stripColon = function (time) {
    return "".concat(time.substring(0, 2)).concat(time.slice(-2));
};
exports.stripColon = stripColon;
var getDayFromDateObject = function (date) {
    return date.toLocaleString("en-US", { weekday: "long" });
};
exports.getDayFromDateObject = getDayFromDateObject;
var getCurrentDateString = function () {
    var today = new Date();
    return "".concat(today.toLocaleString("default", { year: "numeric" })).concat(today.toLocaleString("default", { month: "2-digit" })).concat(today.toLocaleString("default", { day: "2-digit" }));
};
exports.getCurrentDateString = getCurrentDateString;
var getMonthFromDateTimeString = function (dateTime) {
    if (!isNaN(Number(dateTime)))
        return (0, exports.getDateFromDateTimeString)(dateTime).toLocaleString("default", { month: "2-digit" });
    else
        return new Date().toLocaleString("default", { month: "2-digit" });
};
exports.getMonthFromDateTimeString = getMonthFromDateTimeString;
var getYearFromDateTimeString = function (dateTime) {
    if (!isNaN(Number(dateTime)))
        return (0, exports.getDateFromDateTimeString)(dateTime).toLocaleString("default", { year: "numeric" });
    else
        return new Date().toLocaleString("default", { year: "numeric" });
};
exports.getYearFromDateTimeString = getYearFromDateTimeString;
